import React, { Component } from 'react';
import { asyncConnect } from 'react-async-client';
import { Modal, Row, Col, Button } from 'antd';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';
import translate from 'counterpart';
import { path, assocPath } from 'ramda';

import withFormWrapper from 'components/hocs/withFormWrapper';
import { CODE } from 'constants/regexp';
import { getMetroPosition } from 'actions/asyncActions';
import ErrorHTML from 'components/common/form/ErrorHTML';
import InputNumberMask from 'components/common/form/InputNumberMask';
import { required } from 'utils/validators';

@asyncConnect({
    getMetroPosition: getMetroPosition
        .withParams(() => ({ cnb: true }))
        .withSuccessHandler(({ close }) => {
            close();
        })
})
@withFormWrapper({
    mapPropsToValues: ({ params }) => ({
        positionCodeApproval: params.positionCode,
    }),
})
class MetroRequestPositionModal extends Component {
    getMetaWithError = (meta) => {
        const errorCode = path(['error', 'status'], meta);

        if (errorCode === 400) {
            return assocPath(['error', 'translate'], 'metro.request.positionError', meta);
        } else {
            return meta;
        }
    }

    renderFooter() {
        const { getMetroPosition: { meta }, handleSubmit, close } = this.props;

        return (
            <Row>
                <Col xs={{ span: 24 }} className="alert-inline alert-inline-footer">
                    <ErrorHTML meta={this.getMetaWithError(meta)} />
                </Col>
                <Col xs={{ span: 24 }}>
                    <Button onClick={close}>
                        <Translate content='events.cancel' />
                    </Button>
                    <Button type='primary' onClick={handleSubmit} disabled={meta.pending}>
                        <Translate content='metro.request.searchCellId' />
                    </Button>
                </Col>
            </Row>
        );
    }

    render() {
        const { modal } = this.props;

        return (
            <Modal
                {...modal}
                title={<Translate content='metro.request.searchCellId' />}
                footer={this.renderFooter()}
            >
                <Field
                    name='positionCodeApproval'
                    component={InputNumberMask}
                    mask={CODE}
                    className='number-search disable-control input-full-width'
                    label={{ content: 'metro.request.positionCode', required: true }}
                    validate={required}
                    placeholder={translate('metro.request.positionCodeApproval')}
                />
            </Modal>
        );
    }
}

const MetroRequestPositionModalView = props => (
    <MetroRequestPositionModal formAction={props.params.onSubmit} {...props} />
);

export default MetroRequestPositionModalView;
